const INDEX_COOP_OPTIMISM_TOKENS = [];
const OPTIMISM_TOKENS = [
    {
        name: 'Synthetix',
        address: '0x8700daec35af8ff88c16bdf0418774cb3d7599b4',
        symbol: 'SNX',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/SNX.svg',
    },
    {
        name: 'Dai Stable Coin',
        address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
        symbol: 'DAI',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://cryptologos.cc/logos/multi-collateral-dai-dai-logo.svg?v=010',
    },
    {
        name: 'Tether USD',
        address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
        symbol: 'USDT',
        decimals: 6,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/USDT.png',
    },
    {
        name: 'Wrapped Bitcoin',
        address: '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
        symbol: 'WBTC',
        decimals: 8,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/WBTC.svg',
    },
    {
        name: '0xBitcoin',
        address: '0xe0BB0D3DE8c10976511e5030cA403dBf4c25165B',
        symbol: '0xBTC',
        decimals: 8,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/0xBTC.png',
    },
    {
        name: 'Chainlink',
        address: '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6',
        symbol: 'LINK',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/LINK.png',
    },
    {
        name: 'Ethereum Name Service',
        address: '0x65559aA14915a70190438eF90104769e5E890A00',
        symbol: 'ENS',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/ENS.png',
    },
    {
        name: 'Synthetix USD',
        address: '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9',
        symbol: 'sUSD',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/sUSD.svg',
    },
    {
        name: 'USD Coin',
        address: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
        symbol: 'USDC',
        decimals: 6,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/USDC.png',
    },
    {
        name: 'Synthetic Ether',
        address: '0xE405de8F52ba7559f9df3C368500B6E6ae6Cee49',
        symbol: 'sETH',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/sETH.svg',
    },
    {
        name: 'Synthetic Bitcoin',
        address: '0x298B9B95708152ff6968aafd889c6586e9169f1D',
        symbol: 'sBTC',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/sBTC.svg',
    },
    {
        name: 'Synthetic Chainlink',
        address: '0xc5Db22719A06418028A40A9B5E9A7c02959D0d08',
        symbol: 'sLINK',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/sLINK.svg',
    },
    {
        name: 'Uniswap',
        address: '0x6fd9d7ad17242c41f7131d257212c54a0e816691',
        symbol: 'UNI',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/UNI.png',
    },
    {
        name: 'LUSD Stablecoin',
        address: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
        symbol: 'LUSD',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/LUSD.svg',
    },
    {
        name: 'Rari Governance Token',
        address: '0xb548f63d4405466b36c0c0ac3318a22fdcec711a',
        symbol: 'RGT',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/RGT.png',
    },
    {
        name: 'Rai Reflex Index',
        address: '0x7FB688CCf682d58f86D7e38e03f9D22e7705448B',
        symbol: 'RAI',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/RAI.svg',
    },
    {
        name: 'Rocket Pool ETH',
        address: '0x9bcef72be871e61ed4fbbc7630889bee758eb81d',
        symbol: 'rETH',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/rETH.png',
    },
    {
        name: 'Paper',
        address: '0x00F932F0FE257456b32dedA4758922E56A4F4b42',
        symbol: 'PAPER',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/PAPER.svg',
    },
    {
        name: 'Sarcophagus',
        address: '0x7c6b91d9be155a6db01f749217d76ff02a7227f2',
        symbol: 'SARCO',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/sarcophagus.png',
    },
    {
        name: 'BitANT',
        address: '0x5029C236320b8f15eF0a657054B84d90bfBEDED3',
        symbol: 'BitANT',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/BitANT.png',
    },
    {
        name: 'BitBTC',
        address: '0xc98B98d17435AA00830c87eA02474C5007E1f272',
        symbol: 'BitBTC',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/BitBTC.png',
    },
    {
        name: 'Lyra',
        address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
        symbol: 'LYRA',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/LYRA.png',
    },
    {
        name: 'UMA Voting Token v1',
        address: '0xE7798f023fC62146e8Aa1b36Da45fb70855a77Ea',
        symbol: 'UMA',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/UMA.png',
    },
    {
        name: 'Perpetual',
        address: '0x9e1028F5F1D5eDE59748FFceE5532509976840E0',
        symbol: 'PERP',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/PERP.png',
    },
    {
        name: 'dForce',
        address: '0x9e5AAC1Ba1a2e6aEd6b32689DFcF62A509Ca96f3',
        symbol: 'DF',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/DF.svg',
    },
    {
        name: 'dForce USD',
        address: '0xbfD291DA8A403DAAF7e5E9DC1ec0aCEaCd4848B9',
        symbol: 'USX',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/USX.svg',
    },
    {
        name: 'BarnBridge Governance Token',
        address: '0x3e7eF8f50246f725885102E8238CBba33F276747',
        symbol: 'BOND',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/BOND.svg',
    },
    {
        name: 'Wrapped Ether',
        address: '0x4200000000000000000000000000000000000006',
        symbol: 'WETH',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/WETH.png',
    },
    {
        name: 'Dentacoin',
        address: '0x1da650c3b2daa8aa9ff6f661d4156ce24d08a062',
        symbol: 'DCN',
        decimals: 0,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/dcn.svg',
    },
    {
        name: 'Kromatika',
        address: '0xf98dcd95217e15e05d8638da4c91125e59590b07',
        symbol: 'KROM',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/KROM.png',
    },
    {
        name: 'Maker',
        address: '0xab7badef82e9fe11f6f33f87bc9bc2aa27f2fcb5',
        symbol: 'MKR',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/MKR.png',
    },
    {
        name: 'Theranos Coin',
        address: '0x3bB4445D30AC020a84c1b5A8A2C6248ebC9779D0',
        symbol: 'LIZ',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/LIZ.png',
    },
    {
        name: 'Mask Network',
        address: '0x3390108E913824B8eaD638444cc52B9aBdF63798',
        symbol: 'MASK',
        decimals: 17,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/MASK.svg',
    },
    {
        name: 'Curve DAO Token',
        address: '0x0994206dfe8de6ec6920ff4d779b0d950605fb53',
        symbol: 'CRV',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/CRV.png',
    },
    {
        name: 'vETH',
        address: '0x8C835DFaA34e2AE61775e80EE29E2c724c6AE2BB',
        symbol: 'vETH',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/WETH.png',
    },
    {
        name: 'vUSDC',
        address: '0xC84Da6c8ec7A57cD10B939E79eaF9d2D17834E04',
        symbol: 'vUSDC',
        decimals: 18,
        chainId: 10,
        logoURI: 'https://ethereum-optimism.github.io/logos/USDC.png',
    },
    ...INDEX_COOP_OPTIMISM_TOKENS,
];
export { INDEX_COOP_OPTIMISM_TOKENS };
export default OPTIMISM_TOKENS;
//# sourceMappingURL=optimism.js.map